import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import styles from "./CompanionTagline.module.scss";

const capabilities = [
  "Your pipeline",
  "Your inbox",
  "Your meetings",
  "Your follow-ups",
  "Your CRM",
];

const CompanionTagline = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <motion.div
      ref={ref}
      className={styles.taglineSection}
      initial={{ opacity: 0, y: 24 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.15 }}
    >
      <p className={styles.headline}>
        Like giving every rep their own Chief of Staff — without adding a single
        headcount.
      </p>

      <div className={styles.capabilities}>
        {capabilities.map((item, index) => (
          <React.Fragment key={item}>
            {index > 0 && <span className={styles.dot} aria-hidden="true" />}
            <span className={styles.capability}>{item}</span>
          </React.Fragment>
        ))}
        <span className={styles.dot} aria-hidden="true" />
        <span className={styles.badge}>one companion</span>
      </div>
    </motion.div>
  );
};

export default CompanionTagline;
